import { createContext } from "react";
import { contextFunctionInit } from "sprint-common-web";

import { ManzanitaMuxSpecificationLanguageMappingListingItem } from "../language-mapping/ManzanitaMuxSpecificationLanguageMappingsSection";
import { defaultMuxSpecificationDashboardItem, MuxSpecificationDashboardItem } from "../MuxSpecificationDashboardItem";

interface IMuxSpecificationDashboardContext {
    muxSpecificationDashboardItem: MuxSpecificationDashboardItem;
    updateManzanitaLanguageSpecificationMapping(item: ManzanitaMuxSpecificationLanguageMappingListingItem): void;
    isLoading: boolean;
}

const initialContextState: IMuxSpecificationDashboardContext = {
    muxSpecificationDashboardItem: defaultMuxSpecificationDashboardItem,
    updateManzanitaLanguageSpecificationMapping: contextFunctionInit,
    isLoading: true
};

export const MuxSpecificationDashboardContext = createContext<IMuxSpecificationDashboardContext>(initialContextState);
